import {Icon} from '~/components/icon'
import {InnerAvatar} from '../inner_avatar'

export const IconAvatar = props => {
	const {radius, icon} = props
	return (
		<InnerAvatar {...props}>
			<Icon name={icon} size={radius * 0.4} />
		</InnerAvatar>
	)
}
